module.exports = __webpack_public_path__ + "static/media/editInformation.2b243392.svg";